document.querySelectorAll('.flash-deals').forEach(function (section) {
  var track = section.querySelector('.flash-deals__products');
  var prevBtn = section.querySelector('.flash-deals__nav-btn--prev');
  var nextBtn = section.querySelector('.flash-deals__nav-btn--next');

  function scrollByCard(direction) {
    if (!track) return;
    var card = track.querySelector('.flash-deals__product-card');
    var amount = card ? card.getBoundingClientRect().width + 16 : 300;
    track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

  var copyBtn = section.querySelector('.flash-deals__copy-btn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-copy');
      if (!code) return;

      var finish = function () {
        var label = copyBtn.querySelector('span');
        var original = label ? label.textContent : '';
        copyBtn.classList.add('is-copied');
        if (label) label.textContent = 'Copied';
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (label) label.textContent = original;
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(finish).catch(function () {
          fallbackCopy(code);
          finish();
        });
      } else {
        fallbackCopy(code);
        finish();
      }
    });
  }

  function fallbackCopy(text) {
    var input = document.createElement('textarea');
    input.value = text;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  }
});
